import { IApiLink } from "@/types"

export enum AsyncOperationStatus {
    accepted = "accepted",
    running = "running",
    runningFairValueEvaluation = "runningFairValueEvaluation",
    succeeded = "succeeded",
    failed = "failed",
    failedFairValueEvaluation = "failedFairValueEvaluation",
    canceled = "canceled",
}

export interface IGetAsyncOperationStatusDto {
    status: AsyncOperationStatus
    link?: IApiLink
}

export default class AsyncOperation {
    status: AsyncOperationStatus
    link?: IApiLink

    constructor({
        status,
        link
    }: IGetAsyncOperationStatusDto) {
        this.status = status
        this.link = link
    }
}
